import { render } from "./ViewMoreUsers.vue?vue&type=template&id=211ee8c2&scoped=true&ts=true&lang=pug"
import script from "./ViewMoreUsers.vue?vue&type=script&lang=ts"
export * from "./ViewMoreUsers.vue?vue&type=script&lang=ts"

import "./ViewMoreUsers.vue?vue&type=style&index=0&id=211ee8c2&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211ee8c2"]])

export default __exports__